import React from 'react'
import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'

import { StatsBlock } from '../common/stats-block'

export function AnalysisCommon(props: {
  value: React.ReactNode
  children: React.ReactNode
}) {
  const { t } = useTranslation()
  return (
    <StatsBlock
      header={
        <StatsBlock.Header>
          <StatsBlock.Title>{t('profile.analysis.analysis')}</StatsBlock.Title>
          <TitleValue>{props.value}</TitleValue>
        </StatsBlock.Header>
      }
    >
      {props.children}
    </StatsBlock>
  )
}
const TitleValue = styled.div`
  color: var(--text-11);

  font-size: 14px;
  font-weight: 700;
`

const Main = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  column-gap: 6px;
  row-gap: 12px;

  color: var(--text-11);
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
`

const Point = styled.div``
const Value = styled.div`
  text-align: end;
  justify-self: end;
  color: var(--text-12);
`
AnalysisCommon.Main = Main
AnalysisCommon.Point = Point
AnalysisCommon.Value = Value
